export const MARKET_PRODUCT_ID = 'dynamic_market_credits'

export function validOfferId(id) {
  return typeof id === 'string' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(id)
}

export function checkoutReady(offer, now = Date.now()) {
  return Boolean(offer && validOfferId(offer.offerId) && ['quoted', 'wheel_ready', 'spun'].includes(offer.status)
    && offer.expiresAt > now && (!offer.wheelEligible || offer.status === 'spun')
    && ['TRY', 'USD'].includes(offer.currency) && Number(offer.amount) > 0 && Number(offer.baseCredits) > 0)
}

export function productFromOffer(offer) {
  return {
    productId: MARKET_PRODUCT_ID, sku: 'dynamic.market', credits: offer.totalCredits, amount: offer.amount, currency: offer.currency,
  }
}

export function paymentReturnRoute(route) {
  return route && (route.name === 'market-dynamic' || (route.name === 'buy'
    && route.params && route.params.productId === MARKET_PRODUCT_ID
    && route.query && validOfferId(route.query.marketOfferId))) ? 'market-dynamic' : 'market'
}
